export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8622.76729803.jpg";